import { render, staticRenderFns } from "./CompContractTermination.vue?vue&type=template&id=746b0b51"
import script from "./CompContractTermination.vue?vue&type=script&lang=js"
export * from "./CompContractTermination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports